import type { ProductUnitItem } from '@weberus/shared-types';

/**
 * 디자인 설계 참고 피그마
 * @see {@link https://www.figma.com/design/IxDIbEO9tR3tXThxQ6TTNg/UPD-1622-PLP%2FSRP-%EB%94%94%EC%9E%90%EC%9D%B8%EA%B0%9C%ED%8E%B8-%EB%B0%8F-%ED%95%98%EC%9D%B4%EB%B8%8C%EB%A6%AC%EB%93%9C-%EC%A0%84%ED%99%98?node-id=788-316129&m=dev}
 * */
export const convertToProductUnitProps = ({ data: item }: ProductUnitItem) => {
  return {
    thumbnail: {
      url: item?.thumbnail,
      alt: `${item?.title} 이미지`,
      badges: item?.thumbnailBadges?.filter(Boolean),
    },
    keyInfo: {
      newRegistered: item?.newRegistered,
      category: item?.category,
      title: item.title,
      adText: item.adText,
    },
    info: {
      locationInfo: item?.locationInfo,
      locationDetails: item?.locationDetails?.filter(Boolean),
      dateInfo: item?.dateInfo,
      review: item?.review,
    },
    benefitBadge: {
      benefitBadges: item?.benefitBadges,
    },
    price: {
      prices: item?.prices.map((price) => ({
        top: {
          infoText: price?.infoText,
          discountRate: price?.discountRate,
          originPrice: price?.originPrice,
          originPriceNote: price?.originPriceNote,
        },
        middle: {
          priceBadge: price?.priceBadge,
          discountPrice: price?.discountPrice,
          discountPriceUnit: price?.discountPriceUnit,
          longTermDays: price?.longTermDays,
          closedInformation: price?.closedInformation,
          dailyPrice: price?.dailyPrice,
        },
        bottom: {
          couponText: price?.couponText,
        },
      })),
    },
    feature: {
      descriptions: item?.descriptions?.filter(Boolean),
    },
  };
};
